import { render, staticRenderFns } from "./startProject.vue?vue&type=template&id=4d6279f6&scoped=true"
import script from "./startProject.vue?vue&type=script&lang=js"
export * from "./startProject.vue?vue&type=script&lang=js"
import style0 from "./startProject.vue?vue&type=style&index=0&id=4d6279f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6279f6",
  null
  
)

export default component.exports